import { render, staticRenderFns } from "./WealthPortfolioV2.vue?vue&type=template&id=f5b94f74&scoped=true"
import script from "./WealthPortfolioV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./WealthPortfolioV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WealthPortfolioV2.vue?vue&type=style&index=0&id=f5b94f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b94f74",
  null
  
)

export default component.exports